import React from 'react'

import { Table, Col, Row, Form } from '_zari/core'

import * as EstadosRequerimiento from 'constants/estadosRequerimiento'

const DetallesTable = ({ detalles, idsMarcados, onChangeCheckbox }) => {
  const [filtroCorrelativo, setFiltroCorrelativo] = React.useState('')
  const [filtroOficina, setFiltroOficina] = React.useState('')

  const detallesFiltrados = React.useMemo(() => {
    return (detalles || []).filter(row => {
      if (filtroCorrelativo) {
        const corr = `${row.correlativo ?? ''}`.toUpperCase()
        if (!corr.includes(filtroCorrelativo.toUpperCase())) return false
      }
      if (filtroOficina) {
        const ofi = `${row.oficinaSolicitante ?? ''}`.toUpperCase()
        if (!ofi.includes(filtroOficina.toUpperCase())) return false
      }
      return true
    })
  }, [detalles, filtroCorrelativo, filtroOficina])

  return (
    <Row>
      <Col md={12}>
        <Row className='mb-2'>
          <Col md={4}>
            <input
              type='text'
              className='form-control form-control-sm'
              placeholder='Filtrar por correlativo...'
              value={filtroCorrelativo}
              onChange={e => setFiltroCorrelativo(e.target.value)}
            />
          </Col>
          <Col md={4}>
            <input
              type='text'
              className='form-control form-control-sm'
              placeholder='Filtrar por oficina...'
              value={filtroOficina}
              onChange={e => setFiltroOficina(e.target.value)}
            />
          </Col>
        </Row>
        <Table
          containerId='table-detalles-requerimientos'
          filas={detallesFiltrados}
          headRows={[
            { label: '' },
            { label: 'CORRELATIVO' },
            { label: 'FECHA' },
            { label: 'GLOSA' },
            { label: 'USUARIO' },
            { label: 'OFICINA' },
            { label: 'ESTADO' }
          ]}
          maxRowsShown={10}
          rowTemplate={(row, k) => (
            <Table.Row key={k}>
              <Table.Cell>
                <Form.Checkbox
                  checked={idsMarcados.some(x => x === row._id)}
                  onChange={() => onChangeCheckbox(row._id)}
                  id={`${row._id}-checkbox-req`}
                  label=''
                />
              </Table.Cell>
              <Table.Cell>{row.correlativo ?? '--'}</Table.Cell>
              <Table.Cell>{row.fechaEmision ?? '--'}</Table.Cell>
              <Table.Cell>{row.glosa ?? '--'}</Table.Cell>
              <Table.Cell>{row.nombreUsuario ?? row.usuario ?? '--'}</Table.Cell>
              <Table.Cell>{row.oficinaSolicitante ?? '--'}</Table.Cell>
              <Table.Cell>
                {row.estado && EstadosRequerimiento.__dictionary[row.estado] ? (
                  <span className={`badge badge-${EstadosRequerimiento.__dictionary[row.estado].color || 'secondary'}`}>
                    {EstadosRequerimiento.__dictionary[row.estado].nombre}
                  </span>
                ) : (row.estado || '--')}
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Col>
    </Row>
  )
}

export default React.memo(DetallesTable)
